import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import { getEvents } from "@/services/eventService";
import EventCard from "@/my_components/Common/EventCard";

const EventCarouse = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEvents({ upcoming: true })
      .then((res) => setEvents(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // A generic, widely-reused "more events" widget (Home.js, BlogDetails.js, CourseRoom.js,
  // and elsewhere, not just the /events page) -- the "show a message instead of hiding"
  // exception belongs only to Events.js's own primary grid on the dedicated /events page, not
  // to this secondary component that happens to also sit there. Hides entirely when empty,
  // everywhere it appears.
  if (loading || events.length === 0) return null;

  return (
    <Swiper
      className="event-activation-1 rbt-arrow-between rbt-dot-bottom-center pb--60"
      slidesPerView={1}
      spaceBetween={24}
      modules={[Navigation, Pagination]}
      pagination={{ el: ".rbt-swiper-pagination", clickable: true }}
      navigation={{ nextEl: ".rbt-arrow-left", prevEl: ".rbt-arrow-right" }}
      breakpoints={{
        481: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
      }}
    >
      {/* <SwiperSlide> stays a direct child of <Swiper> here (not inside a wrapper component)
          -- Swiper only recognizes slides that are its own direct children, and wrapping it
          one level deeper silently breaks the carousel back to plain block flow. */}
      {events.map((event) => (
        <SwiperSlide key={event.id}>
          <EventCard event={event} />
        </SwiperSlide>
      ))}

      <div className="rbt-swiper-arrow rbt-arrow-left">
        <div className="custom-overfolow">
          <i className="rbt-icon feather-arrow-left"></i>
          <i className="rbt-icon-top feather-arrow-left"></i>
        </div>
      </div>

      <div className="rbt-swiper-arrow rbt-arrow-right">
        <div className="custom-overfolow">
          <i className="rbt-icon feather-arrow-right"></i>
          <i className="rbt-icon-top feather-arrow-right"></i>
        </div>
      </div>

      <div className="rbt-swiper-pagination" style={{ bottom: "0" }}></div>
    </Swiper>
  );
};

export default EventCarouse;
